// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BottomBar.css */
.bottom-bar {
  display: flex;
  justify-content: space-between; /* Aligns elements to left and right */
  align-items: center;
  padding-top: 15px;
}

/* Container for left-aligned buttons */
.left-buttons {
  display: flex;
}

/* Container for right-aligned buttons */
.right-buttons {
  display: flex;
  gap: 10px;
}

/* Edit Background Button - Orange */
.edit-btn {
  background-color: #ff9800; /* Orange */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}

/* Hover Effect - Lighter Orange */
.edit-btn:hover {
  background-color: #ffa733; /* Lighter orange */
  color: #ffffff;
}

/* Prevent color change on click */
.edit-btn:active {
  background-color: #e68900 !important;
}

/* Send & Download Button Styles */
.send-btn,
.download-btn {
  display: flex;
  align-items: center;
  gap: 8px; /* Space between icon and text */
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}

/* Download Button */
.download-btn {
  background-color: #ffffff;
  color: #3b82f6;
  border: 1px solid #3b82f6;
}

/* Hover Effect - Light Blue */
.download-btn:hover {
  background-color: #dcebff;
}

/* Click Effect - Darker Blue Instead of Green */
.download-btn:active {
  background-color: #1d4ed8 !important; /* Darker Blue */
  color: white !important;
}

/* Send Button */
.send-btn {
  background-color: #3b82f6;
  color: white;
}

/* Hover Effect - Darker Blue */
.send-btn:hover {
  background-color: #2563eb;
}

/* Click Effect - Even Darker Blue */
.send-btn:active {
  background-color: #1d4ed8 !important;
}

/* Icon Styling */
.btn-icon {
  font-size: 16px; /* Adjust icon size */
}
`, "",{"version":3,"sources":["webpack://./src/components/birthday/BottomBar.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B,EAAE,sCAAsC;EACtE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,yBAAyB,EAAE,WAAW;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qEAAqE;AACvE;;AAEA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,gCAAgC;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qEAAqE;AACvE;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,oCAAoC,EAAE,gBAAgB;EACtD,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,eAAe,EAAE,qBAAqB;AACxC","sourcesContent":["/* BottomBar.css */\r\n.bottom-bar {\r\n  display: flex;\r\n  justify-content: space-between; /* Aligns elements to left and right */\r\n  align-items: center;\r\n  padding-top: 15px;\r\n}\r\n\r\n/* Container for left-aligned buttons */\r\n.left-buttons {\r\n  display: flex;\r\n}\r\n\r\n/* Container for right-aligned buttons */\r\n.right-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n/* Edit Background Button - Orange */\r\n.edit-btn {\r\n  background-color: #ff9800; /* Orange */\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 15px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\r\n}\r\n\r\n/* Hover Effect - Lighter Orange */\r\n.edit-btn:hover {\r\n  background-color: #ffa733; /* Lighter orange */\r\n  color: #ffffff;\r\n}\r\n\r\n/* Prevent color change on click */\r\n.edit-btn:active {\r\n  background-color: #e68900 !important;\r\n}\r\n\r\n/* Send & Download Button Styles */\r\n.send-btn,\r\n.download-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px; /* Space between icon and text */\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 10px 15px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\r\n}\r\n\r\n/* Download Button */\r\n.download-btn {\r\n  background-color: #ffffff;\r\n  color: #3b82f6;\r\n  border: 1px solid #3b82f6;\r\n}\r\n\r\n/* Hover Effect - Light Blue */\r\n.download-btn:hover {\r\n  background-color: #dcebff;\r\n}\r\n\r\n/* Click Effect - Darker Blue Instead of Green */\r\n.download-btn:active {\r\n  background-color: #1d4ed8 !important; /* Darker Blue */\r\n  color: white !important;\r\n}\r\n\r\n/* Send Button */\r\n.send-btn {\r\n  background-color: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n/* Hover Effect - Darker Blue */\r\n.send-btn:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n/* Click Effect - Even Darker Blue */\r\n.send-btn:active {\r\n  background-color: #1d4ed8 !important;\r\n}\r\n\r\n/* Icon Styling */\r\n.btn-icon {\r\n  font-size: 16px; /* Adjust icon size */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
